// Подключенные плагины
const plugins = [
  "print",
  "preview",
  "paste",
  "importcss",
  "searchreplace",
  "autolink",
  "autosave",
  "save",
  "directionality",
  "code",
  "visualblocks",
  "visualchars",
  "fullscreen",
  "image",
  "link",
  "media",
  "template",
  "codesample",
  "table",
  "charmap",
  "hr",
  "pagebreak",
  "nonbreaking",
  "anchor",
  "toc",
  "insertdatetime",
  "advlist",
  "lists",
  "wordcount",
  "imagetools",
  "textpattern",
  "noneditable",
  "help",
  "charmap",
  "quickbars",
  "emoticons"
].join(" ");

export default plugins;
